"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../utils/utils");
var _classnames = _interopRequireDefault(require("classnames"));
var _keyDownHandler = _interopRequireDefault(require("../../handlers/keyDownHandler"));
var _Icons = _interopRequireDefault(require("./Icons"));
var _TooltipCoachmark = _interopRequireDefault(require("./TooltipCoachmark"));
var _DropMenu = _interopRequireDefault(require("./DropMenu"));
var _CheckboxRadio = _interopRequireDefault(require("./CheckboxRadio"));
var _Label = _interopRequireDefault(require("./Label"));
var _SearchInput = _interopRequireDefault(require("../appComponents/SearchInput"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
//TODO UPDATE STORY PROPS , ADD NEW OPTIONS FOR minimalist
var Dropdown = /*#__PURE__*/function (_Component) {
  function Dropdown(props) {
    var _this;
    _classCallCheck(this, Dropdown);
    _this = _callSuper(this, Dropdown, [props]);
    _this.dropdownRef = /*#__PURE__*/_react["default"].createRef();
    _this.quickSearchVal = "";
    var selectedVal = "";
    var selectedLabel = _this.props.placeholder;
    var selectedVals = [];
    props.options.forEach(function (option) {
      if (option.selected != null && option.selected === true) {
        selectedVal = option.value;
        selectedLabel = option.label;
        return;
      }
    });
    if (props.type === "multiSelect") {
      props.options.forEach(function (option) {
        if (option.selected != null && option.selected === true) {
          selectedVals.push(option.value);
          return;
        }
      });
    }
    if ((selectedLabel === "" || selectedLabel == null) && _this.props.options[0].label) {
      selectedLabel = _this.props.options[0].label;
    }
    _this.state = {
      optSelectedValue: selectedVal,
      optSelectedLabel: selectedLabel,
      hoveredIndex: null,
      opened: false,
      storedItems: props.storedItems,
      optSelectedValues: selectedVals
    };
    _this.handleNormalDropdownChange = _this.handleNormalDropdownChange.bind(_this);
    _this.handleItemClick = _this.handleItemClick.bind(_this);
    _this.hoverHandler = _this.hoverHandler.bind(_this);
    _this.fillOptions = _this.fillOptions.bind(_this);
    _this.fillStoredItems = _this.fillStoredItems.bind(_this);
    _this.removeStoredItem = _this.removeStoredItem.bind(_this);
    _this.unselect = _this.unselect.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.close = _this.close.bind(_this);
    _this.isTargetDropdown = _this.isTargetDropdown.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    _this.doScroll = _this.doScroll.bind(_this);
    _this.getStoredItems = _this.getStoredItems.bind(_this);
    _this.overrideState = _this.overrideState.bind(_this);
    return _this;
  }
  _inherits(Dropdown, _Component);
  return _createClass(Dropdown, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.onKeyDownHandler, false);
      document.removeEventListener("click", this.isTargetDropdown, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      //Adjust dropMenu after it is rendered if the dropdown would be bellow viewport
      if (!this.props.forceMenuPosition) {
        if (!prevState.opened && this.state.opened) {
          var viewPortHeight = window.innerHeight || document.documentElement.clientHeight;
          var viewPortWidth = window.innerWidth || document.documentElement.clientWidth;
          var dropdown = this.dropdownRef.current.querySelector(".dropdownContainer");
          var dropBounds = dropdown.getBoundingClientRect();
          var dropdownMenu = this.dropdownRef.current.querySelector(".dropdownContainer ul");
          var dropdownMenuBounds = dropdownMenu.getBoundingClientRect();
          if (viewPortHeight < dropBounds.top + dropBounds.height + dropdownMenuBounds.height) {
            dropdownMenu.style.top = -dropdownMenuBounds.height + "px";
          } else {
            dropdownMenu.style = {};
          }
          if (viewPortWidth < dropdownMenuBounds.left + dropdownMenuBounds.width + 10) {
            dropdown.classList.add("right");
          }
        } else if (prevState.opened && !this.state.opened) {
          var _dropdown = this.dropdownRef.current.querySelector(".dropdownContainer");
          _dropdown.classList.remove("right");
        }
      }
      if (this.props.storable && prevProps.placeholder !== this.props.placeholder) {
        this.setState({
          optSelectedLabel: this.props.placeholder
        });
      }
    }
  }, {
    key: "overrideState",
    value: function overrideState(newState) {
      this.setState(newState);
    }
  }, {
    key: "handleNormalDropdownChange",
    value: function handleNormalDropdownChange(event) {
      var selectedVal = "";
      var selectedLabel = null;
      var selectedOption = null;
      this.props.options.forEach(function (option) {
        if (option.value === event.target.selectedOptions[0].value) {
          selectedLabel = option.label;
          selectedVal = option.value;
          selectedOption = option;
          return;
        }
      });
      this.setState({
        optSelectedValue: selectedVal,
        optSelectedLabel: selectedLabel
      });
      if (this.props.onChange) {
        this.props.onChange(event, null, selectedOption, null, this);
      }
    }
  }, {
    key: "handleItemClick",
    value: function handleItemClick(event) {
      var overrideValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var skipPreCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var option = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var input = this.dropdownRef.current.querySelector('input');
      if (this.props.storable) {
        var items = this.getStoredItems();
        items.push(_objectSpread({}, option));
        this.setState({
          storedItems: items
        });
        if (this.props.onChange) {
          this.props.onChange(event, input, option, items, this);
        }
        this.close();
        return;
      }
      if (event.target.closest(".icons-component.unselect") != null && !skipPreCheck && !this.props.storable) {
        this.unselect();
        return;
      }
      var targetLI = null;
      if (overrideValue) {
        targetLI = {
          dataset: {
            value: overrideValue
          }
        };
      } else {
        targetLI = event.currentTarget;
      }
      var selecVal = this.state.optSelectedValue;
      var selecLabel = this.state.optSelectedLabel;
      var selected = "";
      this.props.options.forEach(function (option) {
        if (option.value === targetLI.dataset.value) {
          selected = option;
          selecVal = option.value;
          selecLabel = option.label;
        }
      });
      this.selectionChange = true;
      this.setState({
        optSelectedValue: selecVal,
        optSelectedLabel: selecLabel
      });
      if (this.props.onChange) {
        this.props.onChange(event, input, selected, this.getStoredItems(), this);
      }
      this.close();
    }
  }, {
    key: "hoverHandler",
    value: function hoverHandler(val) {
      var useLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var scroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var self = this;
      this.props.options.forEach(function (option, index) {
        var label = typeof option.label === "string" ? option.label : option.label.props.children;
        if (typeof label === "string" && label.toLowerCase().indexOf(val.toLowerCase()) === 0) {
          if (scroll) {
            self.doScroll(index);
          }
          self.setState({
            hoveredIndex: index
          });
        }
      });
    }
  }, {
    key: "fillOptions",
    value: function fillOptions() {
      var _this2 = this;
      var self = this;
      var options;
      if (this.props.type === "normal") {
        // Possible properties : {value, disabled, className, style, label }
        options = this.props.options.map(function (element, index) {
          return /*#__PURE__*/_react["default"].createElement("option", {
            key: index,
            className: element.className,
            style: element.style,
            value: element.value,
            disabled: element.disabled ? element.disabled : false
          }, element.dropdownLabel || element.label);
        });
        options.unshift(/*#__PURE__*/_react["default"].createElement("option", {
          key: "unselected",
          value: "",
          hidden: true
        }, " \xA0"));
        return options;
      } else if (this.props.type === "multiSelect") {
        var unselectAllOption = this.props.options.filter(function (option) {
          return option.unselectAll;
        })[0];
        if (this.state.optSelectedValues.length === 0) {
          this.setState({
            optSelectedValues: [unselectAllOption.value]
          });
          this.setState({
            optSelectedLabel: unselectAllOption.label
          });
        } else if (this.state.optSelectedValues.filter(function (value) {
          return value == unselectAllOption.value;
        }).length == 1 && this.state.optSelectedValues.length > 1) {
          this.setState({
            optSelectedValues: _toConsumableArray(this.state.optSelectedValues.filter(function (value) {
              return value !== unselectAllOption.value;
            }))
          });
          this.setState({
            optSelectedLabel: unselectAllOption.label
          });
        }
        options = this.props.options.map(function (element, index) {
          var label = "";
          var selected = self.state.optSelectedValues.filter(function (v) {
            return v == element.value;
          }).length > 0;
          var classes = (0, _classnames["default"])(element.className, {
            "disabled": !!element.disabled,
            "hovered": index === self.state.hoveredIndex,
            "hasDesc": element.desc != null || element.icon != null
          });
          if (element.label != null) {
            label = element.label;
          }
          var listItem = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, element.icon != null && element.icon, element.dropdownLabel || label, element.desc != null && /*#__PURE__*/_react["default"].createElement("p", {
            className: "mice"
          }, element.desc)), /*#__PURE__*/_react["default"].createElement(_CheckboxRadio["default"], {
            type: "checkbox",
            value: element.value,
            checked: selected
          }));
          return {
            className: classes,
            style: element.style,
            value: element.value,
            selected: selected,
            onClick: function onClick(e) {
              e.persist();
              if (element.onClick != null) {
                element.onClick(e, element);
                _this2.close();
              } else {
                var updatedSelectedOptions = [];
                if (element.unselectAll) {
                  updatedSelectedOptions = [];
                  _this2.setState({
                    optSelectedValues: updatedSelectedOptions
                  });
                  _this2.close();
                } else if (selected) {
                  updatedSelectedOptions = _toConsumableArray(_this2.state.optSelectedValues.filter(function (v) {
                    return v !== element.value;
                  }));
                  _this2.setState({
                    optSelectedValues: updatedSelectedOptions
                  });
                } else {
                  updatedSelectedOptions = [].concat(_toConsumableArray(_this2.state.optSelectedValues), [element.value]);
                  _this2.setState({
                    optSelectedValues: updatedSelectedOptions
                  });
                }
                _this2.props.onChange(e, null, updatedSelectedOptions, null, _this2);
              }
            },
            label: listItem
          };
        });
        return options;
      } else {
        // Possible properties : {value, disabled, className, style, icon, label, desc, onClick }
        options = this.props.options.map(function (element, index) {
          var label = "";
          var selected = element.value === self.state.optSelectedValue;
          var classes = (0, _classnames["default"])(element.className, {
            "disabled": !!element.disabled,
            "hovered": index === self.state.hoveredIndex,
            "hasDesc": element.desc != null || element.icon != null
          });
          if (element.label != null) {
            label = element.label;
          }
          var listItem = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, element.icon != null && element.icon, element.dropdownLabel || label, element.desc != null && /*#__PURE__*/_react["default"].createElement("p", {
            className: "mice"
          }, element.desc)), _this2.props.enableUnselect && selected && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
            name: "micro-glyph-remove",
            typeStyle: "off",
            type: "framed-icon-ext-1",
            classNameContainer: "unselect"
          }), element.onClick == null && selected && !_this2.props.enableUnselect && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
            className: "selectedCheckmark",
            name: "micro-glyph-checkmark",
            type: 'micro-glyph-grape'
          }));
          var curOption = {
            className: classes,
            style: element.style,
            value: element.value,
            selected: selected,
            label: listItem,
            nonSelectable: element.nonSelectable
          };
          if (!element.nonSelectable) {
            curOption.onClick = function (e) {
              if (element.onClick != null) {
                element.onClick(e, element);
                _this2.close();
              } else {
                _this2.handleItemClick(e, null, null, element);
              }
            };
          }
          return curOption;
        });
        if (this.props.type === "search") {
          options.unshift({
            className: "",
            value: "searchInput",
            label: /*#__PURE__*/_react["default"].createElement(_SearchInput["default"], {
              placeholder: this.props.searchPlaceholder,
              onChange: this.props.searchOnChange,
              fieldStyle: "boxed",
              autoResize: false,
              clearable: true,
              clearText: /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
                name: "glyphs-close"
              })
            })
          });
        }
        if (this.props.storable) {
          options = options.filter(function (el) {
            return !_this2.getStoredItems().find(function (storedItem) {
              return storedItem.value === el.value;
            });
          });
        }
        return options;
      }
    }
  }, {
    key: "fillStoredItems",
    value: function fillStoredItems() {
      var _this3 = this;
      //{label, desc, className}
      return this.getStoredItems().map(function (item, index) {
        var className = (0, _classnames["default"])("storedItem", item.className != null ? item.className : "");
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          className: className
        }, /*#__PURE__*/_react["default"].createElement("p", null, item.label, /*#__PURE__*/_react["default"].createElement("span", null, item.desc)), /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
          name: "glyph-remove",
          onClick: function onClick() {
            _this3.removeStoredItem(index);
          }
        }));
      });
    }
  }, {
    key: "removeStoredItem",
    value: function removeStoredItem(index) {
      var items = this.getStoredItems();
      var deletedItems = items.splice(index, 1);
      this.setState({
        storedItems: items
      });
      if (this.props.onChange) {
        this.props.onChange(null, {
          name: this.props.name
        }, deletedItems[0], items, this);
      }
    }
  }, {
    key: "unselect",
    value: function unselect() {
      this.setState({
        optSelectedValue: "",
        optSelectedLabel: this.props.placeholder
      });
      this.close();
    }
  }, {
    key: "show",
    value: function show(e) {
      if (this.state.opened === true && this.props.closeOnClickSelf === true && this.props.type !== "search") {
        this.close();
      } else if (this.state.opened === false) {
        document.addEventListener("click", this.isTargetDropdown, false);
        if (this.props.type !== "search") {
          document.addEventListener("keydown", this.onKeyDownHandler, false);
        }
        if (this.props.onOpen) {
          this.props.onOpen();
        }
        this.setState({
          opened: true
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      if (this.state.opened === true) {
        document.removeEventListener("click", this.isTargetDropdown, false);
        if (this.props.type !== "search") {
          document.removeEventListener("keydown", this.onKeyDownHandler, false);
        }
        if (this.props.onClose) {
          this.props.onClose();
        }
        this.setState({
          opened: false,
          hoveredIndex: null
        });
      }
    }
  }, {
    key: "isTargetDropdown",
    value: function isTargetDropdown(event) {
      if (!(0, _utils.Contains)(this.dropdownRef.current, event.target)) {
        this.close();
      }
    }
  }, {
    key: "onKeyDownHandler",
    value: function onKeyDownHandler(event) {
      var _this4 = this;
      event.preventDefault();
      var key = _keyDownHandler["default"].getKeysFromEvent(event);
      var self = this;
      var index = this.state.hoveredIndex !== null ? this.state.hoveredIndex : -1;
      switch (key) {
        //up
        case _keyDownHandler["default"].keys.up:
          index = index - 1 < 0 ? this.props.options.length - 1 : index - 1;
          this.setState({
            hoveredIndex: index
          });
          self.doScroll(index);
          break;
        //down
        case _keyDownHandler["default"].keys.down:
          index = index + 1 > this.props.options.length - 1 ? 0 : index + 1;
          this.setState({
            hoveredIndex: index
          });
          self.doScroll(index);
          break;
        //enter
        //spacebar
        case _keyDownHandler["default"].keys.enter:
        case _keyDownHandler["default"].keys.spacebar:
          if (index > -1) {
            this.props.options.forEach(function (option, i) {
              if (i === index && self.state.opened) {
                self.setState({
                  optSelectedValue: option.value,
                  optSelectedLabel: option.label
                });
                self.handleItemClick(event, option.value, true);
                self.close();
              }
            });
          }
          break;
        default:
          this.quickSearchVal += key;
          this.hoverHandler(this.quickSearchVal, true, true);
          clearTimeout(this.typingTimer);
          this.typingTimer = setTimeout(function () {
            _this4.quickSearchVal = "";
          }, 300);
          break;
      }
    }
  }, {
    key: "doScroll",
    value: function doScroll(index) {
      var dropdownUl = this.dropdownRef.current.getElementsByTagName('ul')[0];
      var liHeight = dropdownUl.children[0].offsetHeight;
      dropdownUl.scroll(0, index * liHeight);
    }
  }, {
    key: "getStoredItems",
    value: function getStoredItems() {
      if (this.props.controlledStoredItems) {
        return this.props.storedItems;
      }
      return this.state.storedItems;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var options = this.fillOptions();
      var storedItems = [];
      if (this.props.storable) {
        storedItems = this.fillStoredItems();
      }
      var className = (0, _classnames["default"])("dropdown-component", this.props.shapeSytle, this.props.className, this.props.type, {
        "disabled": this.props.disabled,
        "hasLabel": this.props.label != null,
        "hasPlaceholder": this.props.placeholder != null,
        "filled": this.state.optSelectedValue !== "" || this.getStoredItems().length > 0,
        "opened": this.state.opened,
        "showOverSelf": this.props.showOverSelf,
        "storable": this.props.storable,
        "locked": this.props.locked
      });
      var actions = {};
      if (!this.props.locked) {
        if (["custom", "search", "multiSelect"].includes(this.props.type)) {
          actions = {
            onClick: function onClick(e) {
              _this5.show(e);
            }
          };
          if (this.props.type !== "search") {
            actions.onKeyDown = function (event) {
              var key = _keyDownHandler["default"].getKeysFromEvent(event);
              if (key === _keyDownHandler["default"].keys.spacebar) {
                event.preventDefault();
                if (!_this5.state.opened) {
                  _this5.show(event);
                }
              }
            };
          }
          if (this.props.closeOnMouseOut) {
            actions.onMouseLeave = function (e) {
              _this5.close(e);
            };
          }
        }
      }
      var selectedInput = this.state.optSelectedLabel != null ? this.state.optSelectedLabel : "";
      if (this.state.opened && this.props.openedLabel != null) {
        selectedInput = this.props.openedLabel;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className,
        id: this.props.id,
        ref: this.dropdownRef,
        style: this.props.style
      }, this.props.label && /*#__PURE__*/_react["default"].createElement("label", null, this.props.label), /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: "dropdownContainer ".concat(this.props.forceMenuPosition ? this.props.forceMenuPosition : "")
      }, actions), this.props.type === "normal" ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("select", {
        autoComplete: "false",
        name: this.props.name,
        disabled: this.props.disabled,
        tabIndex: this.props.tabIndex,
        value: this.state.optSelected,
        required: this.props.required,
        "data-placeholder": this.props.placeholder,
        onChange: function onChange(e) {
          return _this5.handleNormalDropdownChange(e);
        }
      }, options), /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
        name: "micro-glyph-arrow-head"
      })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
        autoComplete: "false",
        type: "text",
        name: this.props.name,
        disabled: this.props.disabled,
        tabIndex: this.props.tabIndex,
        required: this.props.required,
        value: this.state.optSelectedValue != "" ? this.state.optSelectedValue : selectedInput,
        onChange: function onChange() {}
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_DropMenu["default"], {
        header: this.props.header,
        values: options,
        footer: this.props.footer
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "selectedContainer"
      }, this.props.type === "multiSelect" ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "selectedContainer"
      }, /*#__PURE__*/_react["default"].createElement("span", null, selectedInput), this.state.optSelectedValues.length >= 1 && this.state.optSelectedValues.filter(function (opt) {
        return opt === _this5.props.options.filter(function (option) {
          return option.unselectAll;
        })[0].value;
      }).length === 0 && /*#__PURE__*/_react["default"].createElement(_Label["default"], {
        colorTheme: "teal",
        shapeStyle: "fill",
        type: "count",
        text: this.state.optSelectedValues.length
      }), /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
        name: this.props.storable ? "glyph-plus" : this.props.locked ? "icon-outline-lock" : "micro-glyph-arrow-head"
      })) : /*#__PURE__*/_react["default"].createElement("span", {
        className: "selectedInput"
      }, selectedInput), ["custom", "search"].includes(this.props.type) && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
        name: this.props.storable ? "glyph-plus" : this.props.locked ? "icon-outline-lock" : "micro-glyph-arrow-head"
      }))), this.props.storable && /*#__PURE__*/_react["default"].createElement("div", {
        className: "storedItems"
      }, " ", storedItems, " "), /*#__PURE__*/_react["default"].createElement("div", {
        className: "messageContainer ".concat(this.props.message ? "show" : "")
      }, this.props.message), /*#__PURE__*/_react["default"].createElement(_TooltipCoachmark["default"], {
        isControlled: true,
        state: this.props.showCoachmark ? "show" : "hide",
        position: "right",
        type: "coachmark-icon"
      }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
        name: "glyph-arrow"
      })));
    }
  }]);
}(_react.Component);
;
Dropdown.propTypes = {
  type: _propTypes["default"].oneOf(["normal", "custom", "multiSelect", "search"]),
  shapeSytle: _propTypes["default"].oneOf(["line", "outline", "borderless", "minimalist", "boxed"]),
  name: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(_propTypes["default"].object),
  // Can have {value, disabled, className, style, icon, label, desc, nonSelectable }
  disabled: _propTypes["default"].bool,
  locked: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  placeholder: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  openedLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  onChange: _propTypes["default"].func,
  // Will return (event, input, CurrentOption, storedItems)
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  closeOnMouseOut: _propTypes["default"].bool,
  closeOnClickSelf: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  tabIndex: _propTypes["default"].number,
  id: _propTypes["default"].string,
  storable: _propTypes["default"].bool,
  storedItems: _propTypes["default"].array,
  showCoachmark: _propTypes["default"].bool,
  enableUnselect: _propTypes["default"].bool,
  showOverSelf: _propTypes["default"].bool,
  forceMenuPosition: _propTypes["default"].oneOf([null, "left", "right"]),
  dropdownLabel: _propTypes["default"].string,
  searchOnChange: _propTypes["default"].func,
  searchPlaceholder: _propTypes["default"].string,
  footer: _propTypes["default"].object,
  header: _propTypes["default"].object,
  controlledStoredItems: _propTypes["default"].bool
};
Dropdown.defaultProps = {
  type: "normal",
  shapeSytle: "line",
  name: "",
  options: [],
  disabled: false,
  required: false,
  placeholder: null,
  openedLabel: null,
  label: null,
  onChange: null,
  onOpen: null,
  onClose: null,
  closeOnMouseOut: false,
  closeOnClickSelf: true,
  className: "",
  style: {},
  tabIndex: 1,
  id: null,
  storable: false,
  storedItems: [],
  message: null,
  showCoachmark: false,
  enableUnselect: false,
  showOverSelf: false,
  forceMenuPosition: null,
  dropdownLabel: null,
  searchOnChange: null,
  searchPlaceholder: "",
  footer: null,
  header: null,
  controlledStoredItems: false
};
var _default = exports["default"] = Dropdown;